import { theme } from '@approvalmax/theme';
import { List } from '@approvalmax/ui/src/components';
import styled from 'styled-components';

export const Root = styled(List.Item)`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 8px;
    border-radius: ${theme.radius.xsmall};

    &:hover {
        background-color: ${theme.color.silver80};
    }
`;
